import { useGetMcpServersAvailableToPortalQuery } from '../../../../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc.hooks';
export const useMcpSupportedApps = () => {
  const {
    data,
    loading,
    error,
    networkStatus
  } = useGetMcpServersAvailableToPortalQuery();
  return {
    data: (data === null || data === void 0 ? void 0 : data.mcpServers) || [],
    loading,
    error: error || null,
    networkStatus
  };
};